import React from "react";
import { RoomState } from "@uno/protocol";
import { AppContext } from "../context";
import hostIntegration from "../integrations/host";
import useStoreRoom from "../store/useStoreRoom";

const ACTIVE_GAME_STATES = new Set<RoomState>([
    RoomState.Distribution,
    RoomState.Playing,
    RoomState.WaitingColorChoice,
    RoomState.Closing,
]);

const useHostGameStatus = () => {
    const { isConnected } = React.useContext(AppContext);
    const roomState = useStoreRoom((state) => state.room?.state);
    const roomIsPlaying = Boolean(
        isConnected
        && roomState
        && ACTIVE_GAME_STATES.has(roomState),
    );

    React.useEffect(() => {
        hostIntegration.syncGameStatus({
            ready: isConnected,
            roomIsPlaying,
        });
    }, [isConnected, roomIsPlaying]);
};

export default useHostGameStatus;
